// extracted by mini-css-extract-plugin
export default {"marker":"map-vehicle-builder_marker__f-VfV"};